var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('GlowHint',{staticClass:"mr-2",attrs:{"color":_vm.colorHint}}),_c('div',{staticClass:"flex-fill font-weight-bold text-capitalize"},[_vm._v("\n    "+_vm._s(_vm.currentLabel)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }